// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"106":"b48fa162","200":"536c85a3","209":"67256567","289":"de20848d","399":"e32cdc6c","421":"19dba583","453":"d3c6ef51","475":"b4ac8d17","568":"fb5dd2bf","827":"b34c2757"}[chunkId] + ".chunk.js";
};